import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';
import { EwicBalanceInquiryDTO } from '../business-logic/handle-balance-inquiry';

export const eWicBalanceInquiry = async (data: EwicBalanceInquiryDTO): Promise<IReceipt[]> => {
  const transactionId: string = store.getState().transaction.transactionId;
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/ewic-balance-inquiry`,
    method: 'POST',
    data: data,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
    spanOptions: { name: 'post-ewic-balance-inquiry' },
  };

  return await emeraldRequest<IReceipt[]>(emeraldRequestParams);
};
